import CurrencyModel from 'Models/CurrencyModel';

const RegionModel = {};

RegionModel.USA = {
  id: 1,
  title: 'USA',
  shortTitle: 'USA',
  regionCode: 'US',
  currency: CurrencyModel.USD,
  nationality: 'American',
};
RegionModel.EU = {
  id: 2,
  title: 'Europe',
  shortTitle: 'EU',
  regionCode: 'EU',
  currency: CurrencyModel.EUR,
  nationality: 'European',
};

RegionModel.LIST = [
  RegionModel.USA,
  RegionModel.EU,
];

RegionModel.ID_TO_DATA = {
  [RegionModel.USA.id]: RegionModel.USA,
  [RegionModel.EU.id]: RegionModel.EU,
};

RegionModel.REGION_COOKIE = 'region';

export default RegionModel;
